import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class FltPathLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'fltpath';
        settings["api_endpt"] = "FltPathJSON.php";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        if( settings['scale'] == undefined ) settings["scale"] = 1;
        if( settings['path'] == undefined ) settings["path"] = "KORD,KDEN";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "path", this.settings['path'] );
        return url.toString();
    }

    getIconSize( feature ){
        return this.settings['scale']*20;
    }

    getIcon( feature ){
        let params = "";
        if( this.property(feature,'type') == "ARP" )
            params = params + "code=ARP";
        else if( this.property(feature,'type') == "VOR" )
            params = params + "code=VOR";
        else if( this.property(feature,'type') == "FIX" )
            params = params + "code=FIXN";
        else
            params = params + "code=RNAV";
        if( this.settings['scale'] != 1 )
            params = params + "&scale="+this.settings['scale'];
        return this.icon_path+'/wxicon.php?'+params;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = this.this.property(feature,feature,'id');
        }
        return str;
    }

    getPopupText( feature ){
        let type = "";
        if( this.property(feature,'location') != undefined )
            type = this.property(feature,'location');
        else
            type = "Path";
        let text = this.popupTitle( "FLTPATH", type );
        if( this.property(feature,'id') != undefined )
            text += this.popupData( "Id", this.property(feature,'id') );
        if( this.property(feature,'type') != undefined && 
                this.property(feature,'type') != "FlightPath" )
            text += this.popupData( "Type", this.property(feature,'type'));
        if( this.property(feature,'path') != undefined )
            text += this.popupData( "Path", this.property(feature,'path'));
        if( this.property(feature,'coordinates') != undefined )
            text += this.popupData( "Coordinates", this.property(feature,'coordinates'));
        if( this.property(feature,'raw_taf') != undefined ){
            let taf = this.property(feature,'raw_taf').replace( "FROM", "<br/>&nbsp;&nbsp;FROM" );
            taf = taf.replace( /FM0/g, "<br/>&nbsp;&nbsp;FM0" );
            taf = taf.replace( /FM1/g, "<br/>&nbsp;&nbsp;FM1" );
            taf = taf.replace( /FM2/g, "<br/>&nbsp;&nbsp;FM2" );
            taf = taf.replace( /FM3/g, "<br/>&nbsp;&nbsp;FM3" );
            taf = taf.replace( /TEMPO/g, "<br/>&nbsp;&nbsp;TEMPO" );
            taf = taf.replace( /BECMG/g, "<br/>&nbsp;&nbsp;BECMG" );
            taf = taf.replace( /PROB/g, "<br/>&nbsp;&nbsp;PROB" );
            taf = taf.replace( /INTER/g, "<br/>&nbsp;&nbsp;INTER" );
            text += this.popupData( "TAF", taf );
        }

        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }
        let style = new Style({
                "image": icon,
                "stroke": new Stroke({
                        "color": "magenta",
                        "width": 4,
                        "offsetX": 20,
                        "offsetY": -5
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": "black"
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "offsetX": -20,
                        "offsetY": 12
                        })
                });
        return style;
    }

}
